import { merge } from 'lodash';
import Raven from 'raven-js';
import { getServiceArea } from '@patsnap/common-ps-tracer/src/consts';
let unpushedTrackEventsStack = [];
let inited = false;
export const isProd = ['backoffice.']
    .some(s => location.host.indexOf(s) === 0);
const RavenInsertMeta = (category, action, attr) => {
    const region = getServiceArea().toUpperCase();
    attr = merge({
        region,
    }, attr);
    const trackData = {
        module: category,
        action,
        attr,
    };
    Raven.insertMeta(trackData);
};
export function initSentry(userData) {
    if (!userData) {
        return;
    }
    if (inited) {
        return;
    }
    const opts = userData;
    const email = opts.email;
    const accountId = opts.id;
    const companyId = opts.company_id;
    const companyName = opts.company_name;
    const userType = opts.type;
    if (location.search.indexOf('noraven=1') < 0 && process.env.NODE_ENV === 'production') {
        const data = {
            id: accountId,
            email,
            account_id_cipher: accountId,
            company_id_cipher: companyId,
            company_name: companyName,
            user_type: userType,
        };
        Raven.setUserContext(data);
        import('@patsnap/common-ps-tracer')
            .then(m => (m.default ? m.default : m))
            .then(sentryPsPlugin => {
            sentryPsPlugin(Raven, {
                redShiftIntegrationName: 'redshift-segmentdb',
                product: 'BACKOFFICE',
                page: 'new backoffice',
                openSpendTimeTrack: false,
            });
        })
            .then(() => {
            unpushedTrackEventsStack.forEach(trackData => {
                RavenInsertMeta(trackData.module, trackData.action, trackData.attr);
            });
            unpushedTrackEventsStack = [];
        });
    }
    if (!inited) {
        inited = true;
    }
}
Raven.insertMeta = Raven.insertMeta
    ? Raven.insertMeta
    : (trackData) => {
        console.warn('ps-tracer not inited!');
        unpushedTrackEventsStack.push(trackData);
    };
export { RavenInsertMeta, Raven };
